import { render, staticRenderFns } from "./PB-Header.vue?vue&type=template&id=7166cf5a&scoped=true&"
import script from "./PB-Header.vue?vue&type=script&lang=js&"
export * from "./PB-Header.vue?vue&type=script&lang=js&"
import style0 from "./PB-Header.vue?vue&type=style&index=0&id=7166cf5a&prod&scoped=true&lang=css&"
import style1 from "./PB-Header.vue?vue&type=style&index=1&id=7166cf5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7166cf5a",
  null
  
)

export default component.exports